import { render, staticRenderFns } from "./FormChangeMetaDataReport.vue?vue&type=template&id=47c60ec4&scoped=true&lang=pug"
import script from "./FormChangeMetaDataReport.vue?vue&type=script&lang=js"
export * from "./FormChangeMetaDataReport.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetaDataReport.vue?vue&type=style&index=0&id=47c60ec4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c60ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c60ec4')) {
      api.createRecord('47c60ec4', component.options)
    } else {
      api.reload('47c60ec4', component.options)
    }
    module.hot.accept("./FormChangeMetaDataReport.vue?vue&type=template&id=47c60ec4&scoped=true&lang=pug", function () {
      api.rerender('47c60ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/report/FormChangeMetaDataReport.vue"
export default component.exports